// extracted by mini-css-extract-plugin
export default {"item":"ExhibitionsItem_item__sbNuM","title":"ExhibitionsItem_title__vnaee","date":"ExhibitionsItem_date__Qjnlj","image":"ExhibitionsItem_image__ZhiNT"};